// extracted by mini-css-extract-plugin
module.exports = {"tabs":"TagsSelectionModal_tabs__Rm-kG","tab":"TagsSelectionModal_tab__3F2nq","isActiveTab":"TagsSelectionModal_isActiveTab__1iEwP"};